import React, {
    useContext, useMemo 
} from 'react';
import QuoteScreen from './quote';
import {
    DiagnosticFormContext 
} from '../../../../contexts/form';

const GOAL_DATA = {
    ['Drink Less']: {
        quote: 'With Sunnyside, I was able to cut my alcohol consumption down by more than half. Now I enjoy alcohol every so often and feel much better everyday.',
        user: 'Kim',
        duration: 3
    },
    ['Complete Zero']: {
        quote: 'Yesterday I reached 4 months without a drink! Thank you for helping me stay focused.',
        user: 'Mary',
        duration: 2
    },
    ['Not Sure']: {
        quote: 'With Sunnyside, I was able to cut my alcohol consumption down by more than half. Now I enjoy alcohol every so often and feel much better everyday.',
        user: 'Kim',
        duration: 2
    }
};

export const HabitsQuote = (): JSX.Element => {
    const formContext = useContext(DiagnosticFormContext);
    const endGoalAnswer = useMemo(() => {
        return formContext.answers?.endGoal;
    }, [formContext.answers?.endGoal]);
    const backJump = useMemo(() => {
        const drinksBaseline = formContext.answers?.totalDrinksBaseline;

        switch (drinksBaseline) {
        case 0:
            return 2;
        default:
            return 1;
        }
    }, [formContext.answers?.totalDrinksBaseline]);

    return (
        <QuoteScreen
            sectionKey={'habits'}
            title={'You\'re on your way'}
            subtitle={'Thanks for sharing with us. We\'re incorporating your responses to create the perfect plan for you.'}
            quote={(GOAL_DATA[endGoalAnswer] || GOAL_DATA['Drink Less']).quote}
            user={(GOAL_DATA[endGoalAnswer] || GOAL_DATA['Drink Less']).user}
            duration={(GOAL_DATA[endGoalAnswer] || GOAL_DATA['Drink Less']).duration}
            backJump={backJump}
        />
    );
};

export default HabitsQuote;
